// Turns GetFeatures (products-api, via GET /v1/subscription/product_features/:customer_id) into what the wizard needs.
// Plan features list restrictions: a route that isn't listed is allowed, `false` blocks it, and an object holds limits
// (e.g. permission_set_add: 0 means no custom roles, team_add: 2 means up to two teams).

// Seats aren't part of GetFeatures; they come from GET /v1/subscription/account/:id/seats (products-api SubscriptionSeats).
// TODO: remove this fallback once SubscriptionSeats is deployed everywhere the proxy points
export const FALLBACK_SEATS = { total_seats: 2, used_seats: 1, open_seats: 1, is_fallback: true };

const PHONE_ROUTES = [
    'settings/phone-management/numbers/dyl-numbers',
    'settings/phone-management/routing/call-routing-rules',
    'settings/phone-management/routing/ivr-prompts'
];

const TEXT_ROUTES = [
    'settings/phone-management/tcr/brand-registration',
    'settings/phone-management/tcr/campaign-registration'
];

// null means the plan doesn't limit it
const getRouteLimit = (routes, route, key) => {
    const value = routes[route]?.[key];
    return typeof value === 'number' ? value : null;
}

export const toPlanAccess = (features = {}) => {
    const { routes = {}, unique = {}, global = {} } = features.product_features || {};
    // Some plans keep account-wide limits under "global" instead of "unique"
    const limits = { ...global, ...unique };
    const isBlocked = (route) => routes[route] === false;
    const customRoleLimit = getRouteLimit(routes, 'settings/permission-profile', 'permission_set_add');

    return {
        plan_id: features.plan_id,
        custom_roles: customRoleLimit === null || customRoleLimit > 0,
        custom_role_limit: customRoleLimit,
        team_limit: getRouteLimit(routes, 'settings/teams', 'team_add'),
        has_phone: !PHONE_ROUTES.some(isBlocked) && limits.officeView !== false,
        has_text: !TEXT_ROUTES.some(isBlocked) && limits.textView !== false
    };
}
